import { GET_HOW_TO_APPLY_ERROR, GET_HOW_TO_APPLY_START, GET_HOW_TO_APPLY_SUCCESS } from '../../types';

export default function get_how_to_apply(state, action) {
  switch (action.type) {
    case GET_HOW_TO_APPLY_START:
      return { ...state };
    case GET_HOW_TO_APPLY_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case GET_HOW_TO_APPLY_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
